export const generateOrderID = () => {
    
    return 'ORD-' + Math.random().toString(36).substr(2, 9);
}